/* ==========================================================================
 * bb-paneelhulp.js - het scherm van de paneelhulp
 * --------------------------------------------------------------------------
 * De klant tekent zijn dak na. Per vlak: de maten van zijn paneel, hoeveel
 * panelen er naast elkaar liggen, liggend of staand, en welke randen dicht
 * moeten. Er tekent live een svg mee. Daarna kiest hij zijn marge en zijn
 * diameter, en rolt het voordeligste rollenpakket eruit.
 *
 * WAT HIER NIET IN ZIT
 * Geen enkele rekenregel. Alles wat rekent staat in bb-kern.js (window.BBKern),
 * dat regel voor regel uit rekentools/kern.js komt en over duizenden gevallen
 * naast de live WooCommerce-code is gelegd. Alles wat met de winkel praat staat
 * in bb-winkelwagen.js (window.BBWinkel). Dit bestand zet die twee aan het werk
 * en schrijft de tekst op het scherm.
 *
 * Die twee bestanden staan in thema/gedeeld/assets/ en worden ook door de
 * keuzehulp gebruikt. In het thema landen ze gewoon in assets/, dus aan de
 * scriptregels in sections/bb-paneelhulp.liquid verandert er niets.
 *
 * DE NEDERLANDSE TEKSTEN
 * Woord voor woord overgenomen uit bb-paneelhulp.php zoals die op
 * birdblocker.dealdonkeyadmin.nl/panelen-meten/ draait. Er zijn drie plekken
 * met nieuwe tekst, en alledrie omdat WooCommerce daar iets deed wat Shopify
 * niet kent: de meldingen rond de winkelwagenknop. Ze staan bij elkaar in
 * TEKST_WINKELWAGEN, zodat ze in een oogopslag te herkennen zijn.
 *
 * DE TEKENING
 * Gewone inline svg, geen bibliotheek, precies zoals de huidige tool het doet.
 * tekening() raakt het scherm niet aan en leest niets uit de pagina: hij krijgt
 * een lijst vlakken binnen en geeft een stuk svg terug. Daardoor is hij in
 * test/paneelhulp.test.mjs los na te rekenen, zonder browser.
 * ========================================================================== */
(function (global) {
	'use strict';

	var K = global.BBKern;
	var W = global.BBWinkel;

	/* ======================================================================
	 * INSTELLINGEN
	 * ----------------------------------------------------------------------
	 * Startwaarden in invulvelden, geen productgegevens. De klant ziet ze
	 * staan en overschrijft ze met de maat van zijn eigen paneel. 1,70 bij
	 * 1,10 m is de maat van een gangbaar zonnepaneel en is ook de aanname die
	 * de keuzehulp gebruikt, zodat de twee hulpen bij dezelfde invoer op
	 * hetzelfde getal uitkomen.
	 *
	 * In het thema komen ze uit het schema van sections/bb-paneelhulp.liquid,
	 * zodat Gio ze zonder code kan aanpassen. De waarden hieronder zijn de
	 * terugval als dat blok ontbreekt, en ze zijn gelijk aan de plugin.
	 * ==================================================================== */
	var STANDAARD = {
		lang: 170,          /* lange zijde in centimeters */
		kort: 110,          /* korte zijde in centimeters */
		aantal: 10,         /* panelen naast elkaar in een vlak */
		marge: 10,          /* procent speling */
		maxVlakken: 8,      /* bovengrenzen, puur tegen typefouten */
		maxPanelen: 200,
		maxMeters: 2000,
		/* DE PALLETREGEL STAAT UIT, EN DAT IS GEEN VERGISSING.
		   Een Shopify-thema kan de winkelwagentotalen niet aanpassen; daar is
		   een eigen app met een Shopify Function voor nodig. Zolang die er niet
		   is zou de kaart 5 procent beloven en de winkelwagen 0 procent rekenen.
		   Zet deze schakelaar dus pas aan als die korting echt in de
		   winkelwagen valt. */
		toonPalletregel: false,
		naToevoegen: 'winkelwagen',   /* 'winkelwagen' of 'blijf' */
		winkelwagenSecties: ''
	};

	/* De drie nieuwe teksten. WooCommerce handelde de knop server-side af en
	   toonde een WooCommerce-melding na een omleiding; op Shopify gebeurt alles
	   in de browser en moet de melding hier staan. */
	var TEKST_WINKELWAGEN = {
		bezig: 'Bezig met toevoegen...',
		gelukt: 'Gelukt, je pakket ligt in je winkelwagen.',
		/* Shopify voegt bij een 422 NIETS toe, ook de regels die wel konden niet.
		   Die "alles of niets" moet in de melding staan, anders gaat de klant op
		   zoek naar de helft die er wel in zou liggen. */
		mislukt: 'Er kon niets worden toegevoegd, ook de andere lengtes niet. Waarschijnlijk is een van deze rollen net uitverkocht. Probeer het opnieuw of leg de rollen los in je winkelwagen.',
		verbinding: 'Er ging iets mis met de verbinding. Probeer het nog een keer.'
	};

	/* ======================================================================
	 * KLEINE HULPJES, GELIJK AAN DE KEUZEHULP
	 * ==================================================================== */

	function esc(t) {
		return String(t === null || t === undefined ? '' : t)
			.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
	}
	function leesGetal(el) {
		if (!el) { return 0; }
		var n = parseFloat(String(el.value).replace(',', '.'));
		return isFinite(n) ? n : 0;
	}

	/* ======================================================================
	 * DE TEKENING
	 * ----------------------------------------------------------------------
	 * Gewone inline svg, geen bibliotheek. Alles staat in eenheden van het
	 * viewBox, dus de tekening schaalt in zijn geheel mee met de breedte van
	 * het scherm: op een telefoon van 375 px blijft de verhouding kloppen en
	 * hoeft er nooit horizontaal geschoven te worden.
	 *
	 * De bijschriften onder de tekening staan bewust NIET in de tekening maar
	 * er in gewone html onder. Tekst in een geschaald viewBox wordt op een
	 * telefoon onleesbaar klein; html-tekst niet.
	 * ==================================================================== */

	/** De vaste maten van het tekenvlak, in eenheden van het viewBox. */
	var TEKENING = {
		W: 1000,
		/* padT en tussen zijn ruimer dan de tekening zelf nodig heeft, en dat is
		   met opzet. Een rij van tientallen panelen wordt zo plat dat het
		   bijschrift er niet meer in past en boven het vlak komt te staan. Die
		   regel moet ergens kunnen staan, ook boven het eerste vlak en tussen
		   twee vlakken in. */
		padL: 74, padR: 26, padB: 26, padT: 52,
		tussen: 64,      /* ruimte tussen twee vlakken, in eenheden */
		maxH: 560,
		/* Onder deze hoogte past het bijschrift niet meer in het vlak en gaat
		   het erboven staan. Dat was de fout boven de 40 panelen: dan is een rij
		   maar een paar eenheden hoog en stond de tekst er dwars doorheen. */
		tekstPast: 40,
		/* Onder deze breedte per paneel wordt elk blokje een streepje en is de
		   tekening niet meer te lezen; dan tonen we het vlak als een geheel. */
		paneelLeesbaar: 9,
		maxLosgetekend: 40,
		wering: 9        /* de vogelwering wordt zoveel buiten het vlak getekend */
	};

	/**
	 * Bouwt de svg. Pure functie: geen dom, niets uit de pagina.
	 *
	 * @param {array} vlakken [{ lang, kort, aantal, ligging, randen }]
	 * @returns {string} html
	 */
	function tekening(vlakken) {
		var T = TEKENING;
		var bruikbaar = (vlakken || []).filter(K.vlakGeldig);
		if (!bruikbaar.length) {
			return '<p class="bb-ph-grijs">Zodra je de maten invult, verschijnt hier je indeling.</p>';
		}

		var breedstOnvertaald = 0, hoogteSom = 0;
		bruikbaar.forEach(function (g) {
			var b = K.rijBreedte(g);
			if (b > breedstOnvertaald) { breedstOnvertaald = b; }
			hoogteSom += K.rijHoogte(g);
		});
		if (breedstOnvertaald <= 0 || hoogteSom <= 0) { return ''; }

		var ruimteH = T.maxH - T.padT - T.padB - T.tussen * (bruikbaar.length - 1);
		var schaalB = (T.W - T.padL - T.padR) / breedstOnvertaald;
		var schaalH = ruimteH > 0 ? (ruimteH / hoogteSom) : schaalB;
		var schaal = Math.min(schaalB, schaalH);

		var H = T.padT + T.padB + hoogteSom * schaal + T.tussen * (bruikbaar.length - 1);

		var s = '<svg class="bb-ph-svg" viewBox="0 0 ' + T.W + ' ' + Math.round(H) + '" role="img" '
			+ 'aria-label="Tekening van je indeling met de af te dichten randen gemarkeerd">';

		var y = T.padT;
		bruikbaar.forEach(function (g, i) {
			var b = K.rijBreedte(g) * schaal;
			var h = K.rijHoogte(g) * schaal;
			var x = T.padL;

			// Het nummer van het vlak, links naast de rij.
			s += '<circle class="badge" cx="' + (T.padL - 38) + '" cy="' + (y + h / 2) + '" r="20"></circle>';
			s += '<text class="badgetekst" x="' + (T.padL - 38) + '" y="' + (y + h / 2 + 10) + '" text-anchor="middle">' + (i + 1) + '</text>';

			// De panelen. Zijn het er heel veel, dan wordt elk blokje een streepje
			// en is de tekening niet meer te lezen; dan tonen we het vlak als een
			// geheel met het aantal erin.
			var perPaneel = b / g.aantal;
			if (g.aantal <= T.maxLosgetekend && perPaneel >= T.paneelLeesbaar) {
				for (var k = 0; k < g.aantal; k++) {
					s += '<rect class="paneel" x="' + (x + k * perPaneel + 1.5) + '" y="' + (y + 1.5) + '" '
						+ 'width="' + Math.max(1, perPaneel - 3) + '" height="' + Math.max(1, h - 3) + '" rx="2"></rect>';
				}
			} else {
				s += '<rect class="paneel" x="' + x + '" y="' + y + '" width="' + b + '" height="' + h + '" rx="3"></rect>';
				/* Past het bijschrift in het vlak, dan staat het erin. Een rij van
				   veel panelen is maar een paar eenheden hoog terwijl de letter er
				   30 nodig heeft; dan gaat de regel BOVEN het vlak staan in plaats
				   van er dwars doorheen. Dit is de reparatie die de tekening boven
				   de 40 panelen weer leesbaar maakte, en die moest hier mee. */
				if (h >= T.tekstPast) {
					s += '<text class="blokTekst" x="' + (x + b / 2) + '" y="' + (y + h / 2 + 10) + '" text-anchor="middle">'
						+ g.aantal + ' ' + K.paneelWoord(g.aantal) + '</text>';
				} else {
					s += '<text class="blokTekst buiten" x="' + (x + b / 2) + '" y="' + (y - 20) + '" text-anchor="middle">'
						+ g.aantal + ' ' + K.paneelWoord(g.aantal) + '</text>';
				}
			}

			// De vogelwering, net buiten het vlak zodat de rand van de panelen
			// zichtbaar blijft.
			var o = T.wering;
			if (g.randen === 'omtrek') {
				s += '<rect class="wering" x="' + (x - o) + '" y="' + (y - o) + '" width="' + (b + 2 * o) + '" height="' + (h + 2 * o) + '" rx="5"></rect>';
			} else {
				s += '<line class="wering" x1="' + (x - o) + '" y1="' + (y + h + o) + '" x2="' + (x + b + o) + '" y2="' + (y + h + o) + '"></line>';
				if (g.randen === 'onderboven') {
					s += '<line class="wering" x1="' + (x - o) + '" y1="' + (y - o) + '" x2="' + (x + b + o) + '" y2="' + (y - o) + '"></line>';
				}
			}

			y += h + T.tussen;
		});

		s += '</svg>';
		return s;
	}

	/* ======================================================================
	 * HET SCHERM
	 * ==================================================================== */

	function start(wortelEl, G, instellingen) {
		var I = {};
		Object.keys(STANDAARD).forEach(function (n) { I[n] = STANDAARD[n]; });
		Object.keys(instellingen || {}).forEach(function (n) {
			if (instellingen[n] !== null && instellingen[n] !== undefined && instellingen[n] !== '') {
				I[n] = instellingen[n];
			}
		});

		var vGroepen  = wortelEl.querySelector('#bb-ph-groepen');
		var vTekening = wortelEl.querySelector('#bb-ph-tekening');
		var vSubtot   = wortelEl.querySelector('#bb-ph-subtotaal');
		var vErbij    = wortelEl.querySelector('#bb-ph-erbij');
		var vStap2    = wortelEl.querySelector('#bb-ph-stap2');
		var vStap3    = wortelEl.querySelector('#bb-ph-stap3');
		var vUitslag  = wortelEl.querySelector('#bb-ph-uitslag');
		if (!vGroepen || !vTekening || !vSubtot || !vErbij || !vStap2 || !vStap3 || !vUitslag) { return null; }

		var groepen = [];
		var marge   = { soort: 'procent', procent: I.marge, meters: 0 };
		var keuze   = { diameter: 0 };
		var laatstePakket = null;

		/* ---------- stap 1: de vlakken ---------- */

		function nieuwVlak() {
			return {
				lang: I.lang,
				kort: I.kort,
				aantal: I.aantal,
				ligging: 'liggend',
				randen: 'onder'
			};
		}

		function groepKaart(g, i) {
			var n = i + 1;
			var h = '<div class="bb-ph-groep" data-i="' + i + '">';
			h += '<div class="bb-ph-groepkop"><span class="bb-ph-nummer">' + n + '</span> Vlak ' + n;
			if (i > 0) {
				h += '<button type="button" class="bb-ph-weg" data-weg="' + i + '" aria-label="Vlak ' + n + ' verwijderen">Verwijderen</button>';
			}
			h += '</div>';

			h += '<div class="bb-ph-velden">'
				+ '<label class="bb-ph-veld"><span>Lange zijde paneel (cm)</span>'
				+ '<input type="number" id="bb-ph-lang-' + i + '" min="20" max="400" step="1" inputmode="decimal" value="' + esc(g.lang) + '"></label>'
				+ '<label class="bb-ph-veld"><span>Korte zijde paneel (cm)</span>'
				+ '<input type="number" id="bb-ph-kort-' + i + '" min="20" max="400" step="1" inputmode="decimal" value="' + esc(g.kort) + '"></label>'
				+ '<label class="bb-ph-veld"><span>Panelen naast elkaar</span>'
				+ '<input type="number" id="bb-ph-aantal-' + i + '" min="1" max="' + I.maxPanelen + '" step="1" inputmode="numeric" value="' + esc(g.aantal) + '"></label>'
				+ '</div>';

			h += '<p class="bb-ph-vraagje">Hoe liggen de panelen in dit vlak?</p>'
				+ '<div class="bb-ph-radios">'
				+ '<label><input type="radio" name="bb-ph-lig-' + i + '" value="liggend"' + (g.ligging === 'liggend' ? ' checked' : '') + '> <span><b>Liggend</b>, de lange zijde horizontaal</span></label>'
				+ '<label><input type="radio" name="bb-ph-lig-' + i + '" value="staand"' + (g.ligging === 'staand' ? ' checked' : '') + '> <span><b>Staand</b>, de lange zijde rechtop</span></label>'
				+ '</div>';

			h += '<p class="bb-ph-vraagje">Welke randen dicht je af?</p>'
				+ '<div class="bb-ph-radios kolom">'
				+ '<label><input type="radio" name="bb-ph-rand-' + i + '" value="onder"' + (g.randen === 'onder' ? ' checked' : '') + '> <span>Alleen de <b>onderzijde</b> <em>(vogels kruipen van onderaf onder je panelen. Ligt je bovenkant tegen de nok, dan is dit meestal genoeg)</em></span></label>'
				+ '<label><input type="radio" name="bb-ph-rand-' + i + '" value="onderboven"' + (g.randen === 'onderboven' ? ' checked' : '') + '> <span><b>Onder en boven</b></span></label>'
				+ '<label><input type="radio" name="bb-ph-rand-' + i + '" value="omtrek"' + (g.randen === 'omtrek' ? ' checked' : '') + '> <span>De <b>hele omtrek</b>, ook de zijkanten</span></label>'
				+ '</div>';

			h += '<div class="bb-ph-groepsom" id="bb-ph-som-' + i + '"></div>';
			h += '</div>';
			return h;
		}

		function koppel(i) {
			var g = groepen[i];

			['lang', 'kort', 'aantal'].forEach(function (naam) {
				var el = wortelEl.querySelector('#bb-ph-' + naam + '-' + i);
				if (!el) { return; }
				el.addEventListener('input', function () {
					var n = leesGetal(el);
					if (naam === 'aantal') {
						n = Math.floor(n);
						if (n > I.maxPanelen) { n = I.maxPanelen; el.value = String(n); }
					}
					if (n < 0) { n = 0; }
					g[naam] = n;
					ververs();
				});
			});

			Array.prototype.forEach.call(wortelEl.querySelectorAll('[name="bb-ph-lig-' + i + '"]'), function (el) {
				el.addEventListener('change', function () { g.ligging = el.value; ververs(); });
			});
			Array.prototype.forEach.call(wortelEl.querySelectorAll('[name="bb-ph-rand-' + i + '"]'), function (el) {
				el.addEventListener('change', function () { g.randen = el.value; ververs(); });
			});

			var weg = vGroepen.querySelector('[data-weg="' + i + '"]');
			if (weg) {
				weg.addEventListener('click', function () {
					groepen.splice(i, 1);
					tekenGroepen();
				});
			}
		}

		function tekenGroepen() {
			var h = '';
			groepen.forEach(function (g, i) { h += groepKaart(g, i); });
			vGroepen.innerHTML = h;
			groepen.forEach(function (g, i) { koppel(i); });
			vErbij.disabled = groepen.length >= I.maxVlakken;
			vErbij.textContent = groepen.length >= I.maxVlakken
				? 'Meer dan ' + I.maxVlakken + ' vlakken? Neem even contact op'
				: '+ Nog een vlak toevoegen';
			ververs();
		}

		function randTekst(g) {
			if (g.randen === 'omtrek') { return 'hele omtrek'; }
			if (g.randen === 'onderboven') { return 'onder en boven'; }
			return 'alleen onderzijde';
		}

		/* De rekensom per vlak, zo opgeschreven dat de klant hem met een
		   rekenmachine kan nalopen. */
		function groepSom(g) {
			var b = K.rijBreedte(g);
			var h = K.rijHoogte(g);
			var perPaneel = g.ligging === 'staand' ? K.vlakKort(g) : K.vlakLang(g);
			var som = g.aantal + ' ' + K.paneelWoord(g.aantal) + ' × ' + K.meterTekst(perPaneel) + ' = ' + K.meterTekst(b) + ' breed, ' + K.meterTekst(h) + ' hoog';

			if (g.randen === 'omtrek') {
				return som + '<br>hele omtrek: 2 × (' + K.meterTekst(b) + ' + ' + K.meterTekst(h) + ') = <b>' + K.meterTekst(K.vlakMeters(g)) + '</b>';
			}
			if (g.randen === 'onderboven') {
				return som + '<br>onder en boven: 2 × ' + K.meterTekst(b) + ' = <b>' + K.meterTekst(K.vlakMeters(g)) + '</b>';
			}
			return som + '<br>alleen de onderzijde: <b>' + K.meterTekst(K.vlakMeters(g)) + '</b>';
		}

		function ververs() {
			groepen.forEach(function (g, i) {
				var vak = wortelEl.querySelector('#bb-ph-som-' + i);
				if (!vak) { return; }
				vak.innerHTML = K.vlakGeldig(g)
					? groepSom(g)
					: '<span class="bb-ph-grijs">Vul de maten van je paneel en het aantal panelen in, anders telt dit vlak niet mee.</span>';
			});

			vTekening.innerHTML = tekening(groepen);

			var kaal = K.totaalKaal(groepen);
			if (kaal > 0) {
				var regels = '';
				groepen.forEach(function (g, i) {
					if (!K.vlakGeldig(g)) { return; }
					regels += '<li><span>Vlak ' + (i + 1) + ': ' + g.aantal + ' ' + K.paneelWoord(g.aantal) + ' ' + esc(g.ligging) + ', ' + esc(randTekst(g)) + '</span>'
						+ '<b>' + esc(K.meterTekst(K.vlakMeters(g))) + '</b></li>';
				});
				vSubtot.innerHTML = '<ul class="bb-ph-lijst">' + regels
					+ '<li class="totaal"><span>Samen, nog zonder marge</span><b>' + esc(K.meterTekst(kaal)) + '</b></li></ul>';
			} else {
				vSubtot.innerHTML = '';
			}

			// Staat de uitslag al op het scherm, dan schuift die gewoon mee.
			if (keuze.diameter > 0 && kaal > 0) { toonUitslag(); }
		}

		/* ---------- schermopbouw, zelfde manier als de keuzehulp ---------- */

		function toon(vak, html) { vak.innerHTML = html; vak.hidden = false; }
		function verberg(vak) { vak.innerHTML = ''; vak.hidden = true; }
		function naar(vak) {
			if (vak && vak.scrollIntoView) { vak.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
		}
		function fout(vakId, tekst) {
			var f = wortelEl.querySelector('#' + vakId);
			if (f) { f.innerHTML = tekst ? '<span class="bb-ph-fout" role="alert">' + esc(tekst) + '</span>' : ''; }
		}
		function tegelsAan(vak, opKeuze) {
			Array.prototype.forEach.call(vak.querySelectorAll('.bb-ph-tegel'), function (knop) {
				knop.addEventListener('click', function () {
					Array.prototype.forEach.call(vak.querySelectorAll('.bb-ph-tegel'), function (x) {
						x.classList.remove('sel');
						x.setAttribute('aria-pressed', 'false');
					});
					knop.classList.add('sel');
					knop.setAttribute('aria-pressed', 'true');
					opKeuze(knop);
				});
			});
		}

		vErbij.addEventListener('click', function () {
			if (groepen.length >= I.maxVlakken) { return; }
			groepen.push(nieuwVlak());
			tekenGroepen();
			var laatste = vGroepen.lastElementChild;
			if (laatste) { naar(laatste); }
		});

		wortelEl.querySelector('#bb-ph-naarstap2').addEventListener('click', function () {
			var kaal = K.totaalKaal(groepen);
			if (kaal <= 0) {
				fout('bb-ph-fout1', 'Vul eerst de maten van je paneel en het aantal panelen in.');
				return;
			}
			fout('bb-ph-fout1', '');
			verberg(vStap3);
			vUitslag.innerHTML = '';
			keuze.diameter = 0;
			toonStap2();
		});

		/* ---------- stap 2: de marge ---------- */

		function toonStap2() {
			var h = '<p class="bb-ph-vraag">2. Hoeveel speling wil je erbij?</p>'
				+ '<p class="bb-ph-uitleg">Je knipt de borstel op maat, dus een beetje over is prettiger dan een halve meter te kort. '
				+ 'Kies zelf of je een vast aantal meters extra wilt of een percentage. Heb je scherp gemeten en wil je niets extra, zet hem dan op 0.</p>'
				+ '<div class="bb-ph-radios kolom">'
				+ '<label><input type="radio" name="bb-ph-marge" value="procent"' + (marge.soort === 'procent' ? ' checked' : '') + '> <span>Een <b>percentage</b> van het totaal</span></label>'
				+ '<label><input type="radio" name="bb-ph-marge" value="meters"' + (marge.soort === 'meters' ? ' checked' : '') + '> <span>Een vast aantal <b>extra meters</b></span></label>'
				+ '</div>'
				+ '<div class="bb-ph-velden">'
				+ '<label class="bb-ph-veld" id="bb-ph-veld-procent"><span>Marge in procent</span>'
				+ '<input type="number" id="bb-ph-procent" min="0" max="100" step="1" inputmode="decimal" value="' + esc(marge.procent) + '"></label>'
				+ '<label class="bb-ph-veld" id="bb-ph-veld-meters"><span>Extra meters</span>'
				+ '<input type="number" id="bb-ph-extra" min="0" max="200" step="0.1" inputmode="decimal" value="' + esc(marge.meters) + '"></label>'
				+ '</div>'
				+ '<div id="bb-ph-margesom"></div>'
				+ '<p><button type="button" class="bb-ph-knop" id="bb-ph-naarstap3">Volgende stap</button></p>'
				+ '<div id="bb-ph-fout2"></div>';

			toon(vStap2, h);

			Array.prototype.forEach.call(wortelEl.querySelectorAll('[name="bb-ph-marge"]'), function (el) {
				el.addEventListener('change', function () { marge.soort = el.value; margeVerversen(); });
			});
			wortelEl.querySelector('#bb-ph-procent').addEventListener('input', function () {
				marge.procent = Math.max(0, leesGetal(this));
				margeVerversen();
			});
			wortelEl.querySelector('#bb-ph-extra').addEventListener('input', function () {
				marge.meters = Math.max(0, leesGetal(this));
				margeVerversen();
			});
			wortelEl.querySelector('#bb-ph-naarstap3').addEventListener('click', function () {
				var totaal = K.metMarge(K.totaalKaal(groepen), marge);
				if (totaal > I.maxMeters) {
					fout('bb-ph-fout2', 'Dat is meer dan ' + I.maxMeters + ' meter. Neem even contact op, dan maken wij een offerte op maat.');
					return;
				}
				fout('bb-ph-fout2', '');
				vUitslag.innerHTML = '';
				toonStap3();
			});

			margeVerversen();
			naar(vStap2);
		}

		function margeVerversen() {
			var procent = wortelEl.querySelector('#bb-ph-veld-procent');
			var meters = wortelEl.querySelector('#bb-ph-veld-meters');
			if (procent && meters) {
				procent.hidden = (marge.soort !== 'procent');
				meters.hidden = (marge.soort !== 'meters');
			}
			var vak = wortelEl.querySelector('#bb-ph-margesom');
			if (!vak) { return; }

			var kaal = K.totaalKaal(groepen);
			var totaal = K.metMarge(kaal, marge);
			var tekst;
			if (marge.soort === 'procent') {
				tekst = marge.procent > 0
					? K.meterTekst(kaal) + ' + ' + K.procentTekst(marge.procent) + '% = <b>' + K.meterTekst(totaal) + '</b>'
					: K.meterTekst(kaal) + ', zonder marge = <b>' + K.meterTekst(totaal) + '</b>';
			} else {
				tekst = marge.meters > 0
					? K.meterTekst(kaal) + ' + ' + K.meterTekst(marge.meters) + ' extra = <b>' + K.meterTekst(totaal) + '</b>'
					: K.meterTekst(kaal) + ', zonder marge = <b>' + K.meterTekst(totaal) + '</b>';
			}
			vak.innerHTML = '<div class="bb-ph-rekensom">' + tekst + '</div>';
		}

		/* ---------- stap 3: welke diameter ---------- */

		function toonStap3() {
			var ds = K.diameters(G.producten);
			var h = '<p class="bb-ph-vraag">3. Welke diameter past onder jouw panelen?</p>'
				+ '<div class="bb-ph-tegels" data-aantal="' + (ds.length + 1) + '" id="bb-ph-dtegels">';

			ds.forEach(function (d) {
				var lijst = K.vanDiameter(G.producten, d);
				var goedkoopstePerMeter = null;
				lijst.forEach(function (p) {
					var pm = p.centen / p.meters;
					if (goedkoopstePerMeter === null || pm < goedkoopstePerMeter) { goedkoopstePerMeter = pm; }
				});
				h += '<button type="button" class="bb-ph-tegel" data-diameter="' + d + '">'
					+ '<span class="ico">Ø' + d + '</span>'
					+ '<span class="kop">Ø ' + d + ' cm</span>'
					+ '<span class="sub">Voor een opening tot ' + d + ' cm<br>vanaf ' + K.euroUitCenten(Math.round(goedkoopstePerMeter)) + ' per meter</span>'
					+ '</button>';
			});
			h += '<button type="button" class="bb-ph-tegel" data-diameter="0">'
				+ '<span class="ico">📐</span><span class="kop">Ik weet het niet</span>'
				+ '<span class="sub">Vul je opening in, wij kiezen mee</span></button>';
			h += '</div><div id="bb-ph-meten"></div>'
				+ '<p class="bb-ph-uitleg"><b>Hoe kies je de maat?</b> De diameter is de dikte van de borstel. '
				+ 'Meet de opening tussen je dakpannen en de onderkant van je zonnepaneel, op het smalste punt. '
				+ 'Kies de borstel die die opening opvult: hij hoort licht te klemmen, zodat er geen vogel meer onderdoor kan '
				+ 'terwijl de lucht onder je panelen kan blijven stromen. Twijfel je tussen twee maten, neem dan de grootste: '
				+ 'een te dunne borstel laat vogels alsnog door.</p>';

			toon(vStap3, h);
			tegelsAan(wortelEl.querySelector('#bb-ph-dtegels'), function (knop) {
				var d = parseInt(knop.getAttribute('data-diameter'), 10);
				if (d > 0) {
					wortelEl.querySelector('#bb-ph-meten').innerHTML = '';
					keuze.diameter = d;
					toonUitslag();
					naar(vUitslag);
				} else {
					keuze.diameter = 0;
					vUitslag.innerHTML = '';
					toonMeten();
				}
			});
			naar(vStap3);
		}

		/* Het hulpje voor wie de maat niet weet: opening invullen, wij noemen de
		   kleinste borstel die die opening dekt. */
		function toonMeten() {
			var vak = wortelEl.querySelector('#bb-ph-meten');
			vak.innerHTML = '<div class="bb-ph-velden">'
				+ '<label class="bb-ph-veld"><span>Opening tussen dakpan en paneel (cm)</span>'
				+ '<input type="number" id="bb-ph-opening" min="1" max="40" step="0.5" inputmode="decimal" placeholder="bijv. 13"></label>'
				+ '</div><p><button type="button" class="bb-ph-knop" id="bb-ph-adviesknop">Adviseer een maat</button></p>'
				+ '<div id="bb-ph-openingadvies"></div>';

			wortelEl.querySelector('#bb-ph-adviesknop').addEventListener('click', function () {
				var opening = leesGetal(wortelEl.querySelector('#bb-ph-opening'));
				var advies = wortelEl.querySelector('#bb-ph-openingadvies');
				if (opening <= 0) {
					advies.innerHTML = '<span class="bb-ph-fout" role="alert">Vul eerst je opening in centimeters in.</span>';
					return;
				}
				var ds = K.diameters(G.producten);
				var passend = K.passendeDiameter(G.producten, opening);

				if (passend === null) {
					advies.innerHTML = '<div class="bb-ph-melding">Een opening van ' + esc(K.getal(opening)) + ' cm is groter dan onze dikste borstel (Ø'
						+ esc(ds[ds.length - 1]) + ' cm). Neem even contact op, dan kijken we samen wat er wel kan.</div>';
					return;
				}
				advies.innerHTML = '<div class="bb-ph-melding">Bij een opening van <b>' + esc(K.getal(opening)) + ' cm</b> is <b>Ø' + esc(passend)
					+ ' cm</b> de eerste maat die dat opvult. We rekenen het pakket daar meteen voor uit.</div>';
				keuze.diameter = passend;
				toonUitslag();
				naar(vUitslag);
			});
		}

		/* ---------- de eindbeoordeling ---------- */

		function toonUitslag() {
			var lijst = K.vanDiameter(G.producten, keuze.diameter);
			if (!lijst.length) {
				vUitslag.innerHTML = '<div class="bb-ph-melding">Voor Ø' + esc(keuze.diameter) + ' cm hebben we op dit moment niets staan.</div>';
				return;
			}

			var kaal = K.totaalKaal(groepen);
			var totaal = K.metMarge(kaal, marge);
			if (totaal <= 0) { vUitslag.innerHTML = ''; return; }

			/* Dezelfde bovengrens als bij stap 2. Die knop is niet de enige weg
			   hiernaartoe: staat de uitslag eenmaal op het scherm, dan rekent
			   ververs() hem bij elke wijziging in stap 1 opnieuw uit, zonder nog
			   langs stap 2 te komen. Zonder deze regel rekent de hulp daar rustig
			   duizenden rollen uit. */
			if (totaal > I.maxMeters) {
				vUitslag.innerHTML = '<div class="bb-ph-melding">Dat is meer dan ' + I.maxMeters
					+ ' meter. Neem even contact op, dan maken wij een offerte op maat.</div>';
				return;
			}

			var perRol = K.metersPerRol(G.producten, keuze.diameter);
			var nodigRollen = K.rollenNodig(totaal, perRol);
			var pakket = K.goedkoopstePakket(lijst, nodigRollen);
			if (!pakket) { return; }
			laatstePakket = pakket;

			var h = '<h3>Dit heb je nodig</h3>';

			// Per vlak uitgesplitst, zodat de klant het kan narekenen.
			h += '<div class="bb-ph-narekenen"><div class="kop">Zo komen we aan je meters</div><ul class="bb-ph-lijst">';
			groepen.forEach(function (g, i) {
				if (!K.vlakGeldig(g)) { return; }
				var b = K.rijBreedte(g);
				var hh = K.rijHoogte(g);
				var perPaneel = g.ligging === 'staand' ? K.vlakKort(g) : K.vlakLang(g);
				var som;
				if (g.randen === 'omtrek') {
					som = '2 × (' + K.meterTekst(b) + ' + ' + K.meterTekst(hh) + ')';
				} else if (g.randen === 'onderboven') {
					som = '2 × ' + K.meterTekst(b);
				} else {
					som = K.meterTekst(b);
				}
				h += '<li><span>Vlak ' + (i + 1) + ': ' + g.aantal + ' × ' + esc(K.meterTekst(perPaneel)) + ' ' + esc(g.ligging)
					+ ', ' + esc(randTekst(g)) + ' → ' + esc(som) + '</span>'
					+ '<b>' + esc(K.meterTekst(K.vlakMeters(g))) + '</b></li>';
			});
			h += '<li class="tussen"><span>Samen</span><b>' + esc(K.meterTekst(kaal)) + '</b></li>';
			if (marge.soort === 'procent' && marge.procent > 0) {
				h += '<li><span>Marge ' + esc(K.procentTekst(marge.procent)) + '%</span><b>+ ' + esc(K.meterTekst(totaal - kaal)) + '</b></li>';
			} else if (marge.soort === 'meters' && marge.meters > 0) {
				h += '<li><span>Extra meters</span><b>+ ' + esc(K.meterTekst(marge.meters)) + '</b></li>';
			}
			h += '<li class="totaal"><span>Totaal nodig</span><b>' + esc(K.meterTekst(totaal)) + '</b></li>';
			h += '</ul></div>';

			h += '<div class="bb-ph-rekensom">' + esc(K.meterTekst(totaal))
				+ ' afgerond op hele rollen van ' + esc(K.getal(perRol)) + ' m: <b>' + nodigRollen + ' '
				+ (nodigRollen === 1 ? 'rol' : 'rollen') + '</b> Ø' + esc(keuze.diameter) + ' cm</div>';

			h += pakketKaart(pakket, totaal);

			var lengtes = lijst.map(function (p) { return K.getal(p.meters) + ' m'; });
			h += '<p class="bb-ph-uitleg">Wij hebben alle combinaties van ' + esc(lengtes.join(', '))
				+ ' doorgerekend en tonen de goedkoopste. Een lange rol is per meter voordeliger dan hetzelfde aantal meters '
				+ 'in losse rollen, dus dat scheelt echt geld.</p>';

			vUitslag.innerHTML = h;
			koppelKoopknop();
		}

		function pakketKaart(pakket, nodigMeters) {
			var stukken = pakket.regels.map(function (r) { return r.aantal + '× ' + K.getal(r.product.meters) + ' m'; });
			var over = pakket.meters - nodigMeters;

			var h = '<div class="bb-ph-kaart beste">';
			h += '<div class="kop">Voordeligste pakket</div>';
			h += '<div class="som">' + esc(stukken.join(' + ')) + ' = <b>' + esc(K.meterTekst(pakket.meters)) + '</b></div>';

			h += '<ul class="regels">';
			pakket.regels.forEach(function (r) {
				var vanTekst = (r.product.vancenten > r.product.centen)
					? '<s>' + esc(K.euroUitCenten(r.product.vancenten * r.aantal)) + '</s> '
					: '';
				h += '<li><span class="aantal">' + r.aantal + '×</span> '
					+ '<a href="' + esc(r.product.url) + '">' + esc(r.product.naam) + '</a>'
					+ '<span class="prijs">' + vanTekst + esc(K.euroUitCenten(r.product.centen * r.aantal)) + '</span></li>';
			});
			h += '</ul>';

			h += '<div class="totaal"><span>Totaal</span><b>' + esc(K.euroUitCenten(pakket.centen)) + '</b></div>';
			h += '<div class="klein">' + esc(K.euroUitCenten(Math.round(pakket.centen / pakket.meters))) + ' per meter'
				+ (over > 0.001 ? ' · je houdt ' + esc(K.meterTekst(over)) + ' over' : ' · precies genoeg, niets over') + '</div>';

			h += palletRegel(pakket);

			/* WooCommerce had hier een formulier met een nonce dat server-side werd
			   afgehandeld. Op Shopify is het een gewone knop die /cart/add.js
			   aanroept: geen nonce, geen sessiekoekje vooraf, geen server-side
			   controle op koopbare artikelen. Shopify weigert die zelf. */
			h += '<div class="bb-ph-koop">'
				+ '<button type="button" class="bb-ph-knop groot" id="bb-ph-koopknop">Zet dit pakket in mijn winkelwagen</button>'
				+ '<div id="bb-ph-koopmelding" role="status" aria-live="polite"></div>'
				+ '</div>';

			h += '</div>';
			return h;
		}

		function koppelKoopknop() {
			var knop = wortelEl.querySelector('#bb-ph-koopknop');
			if (!knop) { return; }
			knop.addEventListener('click', function () {
				if (!laatstePakket || !W) { return; }
				var melding = wortelEl.querySelector('#bb-ph-koopmelding');
				knop.disabled = true;
				if (melding) { melding.innerHTML = '<div class="bb-ph-melding">' + esc(TEKST_WINKELWAGEN.bezig) + '</div>'; }

				W.pakketToevoegen(laatstePakket, I.winkelwagenSecties).then(function (uit) {
					/* pakketToevoegen geeft { ok, aantalArtikelen, antwoord } terug.
					   Het thema wil de winkelwageninhoud zelf horen, dus gaat
					   uit.antwoord mee en niet het omhulsel eromheen. */
					W.meldWijziging(uit.antwoord);
					if (I.naToevoegen === 'winkelwagen') {
						global.location.href = W.wortel() + 'cart';
						return;
					}
					knop.disabled = false;
					if (melding) {
						melding.innerHTML = '<div class="bb-ph-melding">' + esc(TEKST_WINKELWAGEN.gelukt)
							+ ' <a href="' + esc(W.wortel() + 'cart') + '">Naar mijn winkelwagen</a></div>';
					}
					/* De palletstand hangt aan wat er in de wagen ligt, en dat is
					   net veranderd. Opnieuw ophalen en de uitslag bijwerken. */
					haalWinkelwagen();
				}).catch(function (f) {
					knop.disabled = false;
					if (!melding) { return; }
					var tekst = (f && f.status === 422) ? TEKST_WINKELWAGEN.mislukt : TEKST_WINKELWAGEN.verbinding;
					melding.innerHTML = '<span class="bb-ph-fout" role="alert">' + esc(tekst) + '</span>';
				});
			});
		}

		/* ---------- de palletregel ---------- */

		/**
		 * DE SCHAKELAAR. Zolang de palletkorting niet echt in de winkelwagen
		 * valt, staat deze regel niet op de kaart. Een thema kan de
		 * winkelwagentotalen niet aanpassen; dat kan alleen een eigen app met een
		 * Shopify Function. Zonder die Function zou de kaart 5 procent beloven en
		 * de winkelwagen 0 procent rekenen, en dat merkt niemand tot een klant
		 * belt. Zet hem dus pas aan als de korting bewezen valt.
		 */
		function palletRegel(pakket) {
			if (!I.toonPalletregel) { return ''; }

			var stand = K.palletStand(G, keuze.diameter, pakket);
			if (!stand) { return ''; }

			var wagenTekst = stand.alInWagen > 0
				? ' (inclusief de ' + stand.alInWagen + ' ' + (stand.alInWagen === 1 ? 'rol die' : 'rollen die') + ' al in je winkelwagen ' + (stand.alInWagen === 1 ? 'ligt' : 'liggen') + ')'
				: '';

			if (stand.percentage > 0) {
				return '<div class="bb-ph-pallet klaar">🎉 Dit is <b>' + esc(K.getal(stand.deel)) + ' pallet</b>' + esc(wagenTekst) + '. '
					+ 'Je krijgt <b>' + esc(K.getal(stand.percentage, 0)) + '% palletkorting</b>: dat scheelt ongeveer <b>' + esc(K.euroUitCenten(stand.geschatteKortingCenten))
					+ '</b> op dit pakket. De winkelwagen rekent het exacte bedrag uit.</div>';
			}

			return '<div class="bb-ph-pallet">📦 Dit pakket is <b>' + esc(K.getal(stand.deel)) + ' pallet</b>' + esc(wagenTekst) + '. '
				+ 'Nog <b>' + stand.rollenTotEersteTrede + ' ' + (stand.rollenTotEersteTrede === 1 ? 'rol' : 'rollen') + '</b> van deze maat erbij en je krijgt '
				+ '<b>' + esc(K.getal(G.treden.een, 0)) + '% palletkorting</b> over je hele bestelling.</div>';
		}

		/**
		 * Wat er al in de winkelwagen ligt komt NA de eerste tekening binnen:
		 * Shopify kan de pagina gecachet uitserveren, dus /cart.js is de enige
		 * betrouwbare bron. Tot dat verzoek terug is telt de wagen als leeg, en
		 * dat is beter dan een getal tonen dat straks verspringt.
		 *
		 * Zonder palletregel hoeft dit verzoek helemaal niet: dan gebruikt niets
		 * op het scherm dit getal.
		 */
		function haalWinkelwagen() {
			if (!I.toonPalletregel || !W) { return; }
			W.rollenInWinkelwagen(G.producten).then(function (rollen) {
				G.winkelwagen = rollen;
				if (keuze.diameter > 0) { toonUitslag(); }
			});
		}

		/* ---------- starten ---------- */

		groepen.push(nieuwVlak());
		tekenGroepen();
		haalWinkelwagen();

		return {
			groepen: groepen,
			marge: marge,
			keuze: keuze,
			ververs: ververs,
			instellingen: I
		};
	}

	/* ======================================================================
	 * VANZELF STARTEN
	 * ----------------------------------------------------------------------
	 * Alleen als de section echt op de pagina staat. Zo kan dit bestand ook in
	 * node ingeladen worden om de tekening na te rekenen, zonder browser.
	 * ==================================================================== */
	function autoStart() {
		var doc = global.document;
		if (!doc) { return; }
		Array.prototype.forEach.call(doc.querySelectorAll('[data-bb-paneelhulp]'), function (el) {
			if (el.getAttribute('data-bb-gestart') === '1') { return; }
			el.setAttribute('data-bb-gestart', '1');

			var G = W && W.leesGegevens(el.getAttribute('data-bb-gegevens') || 'bb-rekendata');
			if (!G) {
				el.innerHTML = '<div class="bb-ph-melding">De rekenhulp kan de rollen niet vinden. '
					+ 'Controleer of de collectie in de thema-instellingen klopt en of de velden diameter, meters en rollen gevuld zijn.</div>';
				return;
			}

			var instellingen = {};
			try {
				var blok = doc.getElementById(el.getAttribute('data-bb-instellingen') || 'bb-ph-instellingen');
				if (blok) { instellingen = JSON.parse(blok.textContent || '{}'); }
			} catch (e) { /* terugval op STANDAARD */ }

			start(el, G, instellingen);
		});
	}

	if (global.document) {
		if (global.document.readyState === 'loading') {
			global.document.addEventListener('DOMContentLoaded', autoStart);
		} else {
			autoStart();
		}
		/* De thema-editor bouwt een section opnieuw op zonder de pagina te
		   herladen. Zonder deze regel is de hulp na een instelwijziging dood. */
		global.document.addEventListener('shopify:section:load', autoStart);
	}

	global.BBPaneelhulp = {
		tekening: tekening,
		TEKENING: TEKENING,
		STANDAARD: STANDAARD,
		TEKST_WINKELWAGEN: TEKST_WINKELWAGEN,
		start: start,
		autoStart: autoStart
	};
}(typeof window !== 'undefined' ? window : globalThis));
